import { useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

export const useEmployeeSelection = (me) => {
  const [emps, setEmps] = useState([]);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/employees").then((r) => setEmps(r.data.filter((e) => e.status === "active")));
  }, []);

  const eligible = useMemo(
    () => emps.filter((e) => !(me?.role === "hr_admin" && e.id === me.id)),
    [emps, me]
  );
  const shown = useMemo(
    () => eligible.filter((e) => `${e.name} ${e.employee_code} ${e.department}`.toLowerCase().includes(search.toLowerCase())),
    [eligible, search]
  );

  const toggle = (id) => setSelected((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const allShownSelected = shown.length > 0 && shown.every((e) => selected.includes(e.id));
  const toggleAll = () => setSelected(allShownSelected
    ? selected.filter((id) => !shown.some((e) => e.id === id))
    : [...new Set([...selected, ...shown.map((e) => e.id)])]);

  return { shown, selected, setSelected, search, setSearch, toggle, allShownSelected, toggleAll };
};
